export const PLATFORM_MULTIPLE_USER_COOKIE = "platform-multiple-users";
export const PLATFORM_SELECTED_USER_COOKIE = "platform-selected-user";

export const ENABLE_MULTI_USER_COOKIE = "enable-multi-user";

export const ACCESS_TOKEN = "next-auth.api-token";
export const REFRESH_TOKEN = "next-auth.refresh-token";

export const PUBLIC_PATHS = [
  "/404",
  "/403",
  "/coach-community",
  "/to-whom",
  "/pricing",
  "/legal",
  "/privacy",
  "/terms",
  "/contact",
  "/enterprise",
  "/auth/sign-up",
  "/auth/sign-in",
  "/solution-for-clients",
  "/cookies",
  "/faq",
  "/security",
  "/test",
  "/first-questionaire",
  "/pre-session",
  "/client-satisfaction",
  "/forms/",
  "/learning",
  "/pricing",
  "/code-of-conduct",
  "/coachee",
];
